// src/pages/Complaints.js
import React, { useEffect, useState } from "react";
import { db, collection, getDocs, addDoc } from "../firebase";
import LoadingSpinner from "../components/LoadingSpinner";

export default function Complaints() {
  const [list, setList] = useState([]);
  const [form, setForm] = useState({ driver: "", truck: "", description: "" });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function load() {
      setLoading(true);
      setError(null);
      try {
        const snaps = await getDocs(collection(db, "complaints"));
        setList(snaps.docs.map((d) => ({ id: d.id, ...d.data() })));
        console.log("Complaints data loaded");
      } catch (error) {
        console.error("Error loading complaints:", error);
        setError("Failed to load complaints. Please try again.");
      } finally {
        setLoading(false);
      }
    }
    load();
  }, []);

  async function create(e) {
    e.preventDefault();
    try {
      await addDoc(collection(db, "complaints"), {
        ...form,
        status: "open",
        createdAt: new Date().toISOString(),
      });
      setForm({ driver: "", truck: "", description: "" });
      await load();
    } catch (error) {
      console.error("Error creating complaint:", error);
      setError("Failed to create complaint. Please try again.");
    }
  }

  return (
    <div className="complaints-page">
      {loading ? (
        <LoadingSpinner />
      ) : error ? (
        <div style={{ textAlign: "center", padding: "20px", color: "#b91c1c" }}>
          {error}
        </div>
      ) : (
        <>
          <h2>Complaints / Issues</h2>
          <form className="form-inline" onSubmit={create}>
            <input
              placeholder="Driver name"
              value={form.driver}
              onChange={(e) => setForm({ ...form, driver: e.target.value })}
            />
            <input
              placeholder="Truck reg"
              value={form.truck}
              onChange={(e) => setForm({ ...form, truck: e.target.value })}
            />
            <input
              placeholder="Short description"
              value={form.description}
              onChange={(e) => setForm({ ...form, description: e.target.value })}
            />
            <button className="btn-primary" type="submit">
              Log
            </button>
          </form>
          <table className="simple-table">
            <thead>
              <tr>
                <th>Driver</th>
                <th>Truck</th>
                <th>Description</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {list.map((c) => (
                <tr key={c.id}>
                  <td>{c.driver}</td>
                  <td>{c.truck}</td>
                  <td>{c.description}</td>
                  <td>{c.status}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}
    </div>
  );
}